import { CoreIcon } from '../core-icon';
import arrowRightCircleSVG from '../../../src/images/icons/arrow-right-circle.svg';

export const ArrowRightCircleIcon = props => {
  return <CoreIcon src={arrowRightCircleSVG} {...props} />;
};
